import React from 'react';
import { Popup } from 'semantic-ui-react';

/**
 * @function
 * @param {Object} props - React Props
 * @param {string} props.content - informational content to display on hover
 * @returns {React.ReactNode}
*/
export function LabelPopupIcon({ content }) {
    return (
        <Popup
            content={content}
            position="top center"
            trigger={
                <i
                    className="question circle icon"
                    style={{ marginLeft: "0.2rem", color: "var(--primary-350)" }}>
                </i>
            }
        />
    );
};

